import qs from "qs";
import store from "@/stores/store";
import axios from "@/plugins/axios";
import utils from "@/stores/utils";
import $utils from '@/utils';
import documents from "./submodules/documents";
import allocations from "./submodules/allocations";
import customerstats from "./submodules/customerstats";
import billingaccounts from "./submodules/billingaccounts";
import shipments from "./submodules/shipments";
import receipts from "./submodules/receipts";
import orders from "./submodules/customerorders";
import deliverysites from "./submodules/deliverysites";
import partnercontacts from "./submodules/partnercontacts";
import customercommunications from "./submodules/customercommunications";
import invitations from "./submodules/invitations";
import stocks from "./submodules/stocks";
import products from "./submodules/products";
import catalogassignments from "./submodules/catalogassignments";
import catalogsSubmodule from "./submodules/catalogs";
import { CSV_EXPORT_LIMIT } from '@/constants/csv-export';
import {
    CUSTOMER_INVOICE_LIST_TO_ITEMS,
    buildInvoiceItemsExportOrdering,
    mapInvoiceListFiltersToItemFilters,
} from '@/utils/invoice-items-export-filters';

const { getStorageKey, loadFiltersFromStorage, saveFiltersToStorage } = utils;

const state = {
    customer: null,
    customer_loading: false,
    customer_saving: false,

    monthly_stats: {},
    monthly_stats_loaded: false,
    monthly_stats_loading: false,
    monthly_stats_loading_errors: null,

    stats: null,
    stats_loading: false,
    stats_loading_errors: null,

    ask_user_creation: false,

    invoices: [],
    invoices_filters: { offset: 0, limit: 20 },
    invoices_stats: {},
    invoices_stats_loading: false,
    invoices_count: 0,
    invoices_loading: false,
    invoices_loading_errors: null,

    overdue_invoices_stats: null,
    overdue_invoices_stats_loading: false,

    contractlines: [],
    contractlines_filters: { offset: 0, limit: 20 },
    contractlines_count: 0,
    contractlines_loading: false,
    contractlines_loading_errors: null,

    billingaccount: null,

    catalogs: null,
    catalogs_fetching: false,
    catalogs_fetching_errors: null,

    section: null,

    creating_account: false,

    can_impersonate: false,
};

const mutations = {
    updateInvoices(state, data) {
        state.invoices = data.results;
        state.invoices_count = data.count;
    },
    updateSection(state, section) {
        state.section = section;
    },

    updateInvoicesLoading(state, loading) {
        state.invoices_loading = loading;
    },
    updateInvoicesLoadingErrors(state, errors) {
        state.invoices_loading_errors = errors;
    },
    updateInvoicesFilters(state, filters) {
        state.invoices_filters = filters;
        saveFiltersToStorage(getStorageKey('customer-invoices'), filters, ['limit', 'ordering']);
    },

    updateCustomer(state, customer) {
        if (customer && state.customer && customer.id == state.customer.id) {
            state.customer = customer;
            return;
        }
        state.customer = customer;
        state.stats = null;
        state.monthly_stats_loaded = false;
        state.monthly_stats = [];

        state.invoices = [];
        state.invoices_count = 0;
        state.invoices_loaded = 0;
        state.overdue_invoices_stats = null;

        if (!customer) {
            state.invoices_filters = { offset: 0, limit: state.invoices_filters.limit };
            state.contractlines_filters = {
                offset: 0,
                limit: state.contractlines_filters.limit,
            };
            return;
        }

        state.invoices_filters = {
            ...loadFiltersFromStorage(getStorageKey('customer-invoices', state.section), { limit: 20, ordering: "-invoice_date" }),
            offset: 0,
            billed: customer.id,
        };
        state.contractlines_filters = {
            ...loadFiltersFromStorage(getStorageKey('customer-contractlines', state.section), { limit: 20, ordering: "-id" }),
            offset: 0,
            billed: customer.id,
        };
    },

    updateCustomerSaving(state, saving) {
        state.customer_saving = saving;
    },
    updateCustomerLoading(state, loading) {
        state.customer_loading = loading;
    },

    updateStats(state, stats) {
        state.stats = stats;
        state.stats_loading = false;
        state.stats_loading_errors = null;
    },
    updateStatsLoading(state, loading) {
        state.stats_loading = loading;
        state.stats_loading_errors = null;
    },
    updateStatsLoadingErrors(state, stats_loading_errors) {
        state.stats = {};
        state.stats_loading = false;
        state.stats_loading_errors = stats_loading_errors;
    },

    updateMonthlyStats(state, stats) {
        state.monthly_stats = stats;
        state.monthly_stats_loaded = true;
    },
    updateMonthlyStatsLoading(state, loading) {
        state.monthly_stats_loading = loading;
    },
    updateMonthlyStatsLoadingErrors(state, errors) {
        state.monthly_stats_loading_errors = errors;
    },

    updateContractLines(state, data) {
        state.contractlines = data.results;
        state.contractlines_count = data.count;
        state.contractlines_loading_errors = {};
        state.contractlines_loading = false;
    },
    updateContractLinesLoading(state, loading) {
        state.contractlines_loading = loading;
        state.contractlines_loading_errors = {};
    },
    updateContractLinesLoadingErrors(state, errors) {
        state.contractlines_loading_errors = errors;
        state.contractlines_loading = false;
    },
    updateContractLinesFilters(state, filters) {
        state.contractlines_filters = {
            ...filters,
            billed: state.customer.id,
        };
        saveFiltersToStorage(getStorageKey('customer-contractlines', filters, ['limit', 'ordering']));
    },

    updateBillingAccount(state, billingaccount) {
        state.billingaccount = billingaccount;
        state.billingaccount_loading = false;
        state.billingaccount_loading_errors = null;
    },
    updateBillingAccountLoading(state, billingaccount_loading) {
        state.billingaccount_loading = billingaccount_loading;
    },
    updateBillingAccountLoadingErrors(state, billingaccount_loading_errors) {
        state.billingaccount = null;
        state.billingaccount_loading = false;
        state.billingaccount_loading_errors = billingaccount_loading_errors;
    },

    updateFetchingCatalogs(state) {
        state.catalogs = [];
        state.catalogs_fetching = true;
        state.catalogs_fetching_errors = null;
    },

    updateCatalogs(state, catalogs) {
        state.catalogs = catalogs;
        state.catalogs_fetching = false;
    },

    updateFetchingCatalogsErrors(state, errors) {
        state.catalogs_fetching_errors = errors;
    },

    updateCreatingAccount(state, creating_account) {
        state.creating_account = creating_account;
    },
    updateCanImpersonate(state, can_impersonate) {
        state.can_impersonate = can_impersonate;
    },

    updateInvoicesStats(state, invoices_stats) {
        state.invoices_stats = invoices_stats;
    },

    updateOverdueInvoicesStats(state, data) {
        state.overdue_invoices_stats = data;
        state.overdue_invoices_stats_loading = false;
    },
    updateOverdueInvoicesStatsLoading(state, loading) {
        state.overdue_invoices_stats_loading = loading;
    },

};

const actions = {
    exportInvoicesAsCSV({ commit, dispatch, state }, params) {
        let filters = {};
        if (params.filtered) {
            filters = Object.assign({}, state.invoices_filters);
            filters.offset = null;
        }
        filters.format = "csv";
        filters.billed = state.customer.id;
        filters.limit = CSV_EXPORT_LIMIT;
        
        const customerName = state.customer?.name || '';
        
        $utils.downloadFile({
            url: "/api/customerinvoices/",
            params: filters,
        }, $utils.getFilename('customerInvoices', { customer_name: customerName }));
    },

    exportInvoiceItemsAsCSV({ commit, dispatch, state }, params) {
        let filters = {};
        if (params.filtered) {
            filters = mapInvoiceListFiltersToItemFilters(
                state.invoices_filters,
                CUSTOMER_INVOICE_LIST_TO_ITEMS,
            );
        }
        // Customer tab always scopes lines to this customer.
        if (state.invoices_filters.billed) {
            filters.invoice_billed = state.invoices_filters.billed;
        }
        filters.invoice_issued = true;
        filters.format = "csv";
        filters.limit = CSV_EXPORT_LIMIT;
        filters.ordering = buildInvoiceItemsExportOrdering(
            state.invoices_filters.ordering,
        );

        const customerName = state.customer?.name || '';

        $utils.downloadFile({
            url: "/api/customerinvoiceitems/",
            params: filters,
        }, $utils.getFilename('customerInvoiceItems', { customer_name: customerName }));
    },

    async markInvoiceAsPaid({ commit, dispatch, state }, params) {
        try {
            const response = await axios.post(`/api/customerinvoices/${params.invoice.id}/paid/`, { paid: true });
            return response.data;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        }
    },
    async fetchCatalogs({ commit, dispatch, state }, params) {
        if (
            store.getters["session/current_user_permissions"].indexOf(
                "catalog.view_catalogassignment"
            ) == -1
        ) {
            return;
        }
        if (
            store.getters["session/current_user_permissions"].indexOf(
                "catalog.view_sellcatalog"
            ) == -1
        ) {
            return;
        }

        try {
            commit("updateFetchingCatalogs");
            const response = await axios.get("/api/catalogassignments/", {
                params: { customer: state.customer.id },
            });
            let catalogs = response.data.results.map((item) => item.catalog_data);
            commit("updateCatalogs", catalogs);
            return catalogs;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateFetchingCatalogsErrors", error.details);
            throw error;
        }
    },

    async fetchInvoices({ commit, dispatch, state }, params) {
        commit("updateInvoicesLoading", true);
        commit("updateInvoicesLoadingErrors", null);
        try {
            const response = await axios.get("/api/customerinvoices/", { params: state.invoices_filters });
            commit("updateInvoices", response.data);
            dispatch("fetchInvoicesStats");
            dispatch("fetchOverdueInvoicesStats");
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateInvoicesLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateInvoicesLoading", false);
        }
    },

    async fetchInvoicesStats({ commit, dispatch, state }, params) {
        try {
            const response = await axios.get("/api/customerinvoices/stats/", { params: state.invoices_filters });
            commit('updateInvoicesStats', response.data);
            return response.data;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        }
    },

    async fetchOverdueInvoicesStats({ commit, dispatch, state }, params) {
        if (
            store.getters["session/current_user_permissions"].indexOf("billing.view_invoice") === -1 ||
            !state.customer
        ) {
            return;
        }
        commit("updateOverdueInvoicesStatsLoading", true);
        try {
            const response = await axios.get("/api/customerinvoices/stats/", {
                params: {
                    billed: state.customer.id,
                    paid: false,
                    due: true,
                },
            });
            commit("updateOverdueInvoicesStats", response.data);
            return response.data;
        } catch (xhr_error) {
            commit("updateOverdueInvoicesStats", null);
            return null;
        } finally {
            commit("updateOverdueInvoicesStatsLoading", false);
        }
    },

    async fetchCustomerStats({ commit, dispatch, state }, params) {
        commit("updateStatsLoading", true);
        if (!state.customer) {
            return;
        }
        try {
            let url = `/api/customers/${state.customer.id}/stats/`;
            const response = await axios.get(url, { params: { profile: "customer" } });
            commit("updateStats", response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateStatsLoadingErrors", error.details);
            throw error;
        }
    },

    async fetchCustomer({ commit, dispatch, state }, params) {
        commit("updateCustomerLoading", true);

        let url = null;
        if (params && params.customer_id) {
            url = `/api/customers/${params.customer_id}/`;
        } else if (state.customer) {
            url = `/api/customers/${state.customer.id}/`;
        } else {
            throw "No customer to fetch";
        }
        try {
            const response = await axios.get(url, { params: { profile: "customer" } });
            commit("updateCustomerLoading", false);
            commit("updateCustomer", response.data);
            dispatch("fetchBillingAccount");
            return response.data;
        } catch (xhr_error) {
            commit("updateCustomerLoading", false);
            throw utils.handleError(xhr_error);
        }
    },

    async archiveCustomer({ commit, dispatch, state }, params) {
        const url = `/api/customers/${params.instance.id}/archive/`;
        try {
            const response = await axios.post(url);
            dispatch("fetchCustomer");
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async unarchiveCustomer({ commit, dispatch, state }, params) {
        const url = `/api/customers/${state.customer.id}/unarchive/`;

        try {
            const response = await axios.post(url);
            dispatch("fetchCustomer");
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateCustomerLoading", false);
            throw error;
        }
    },


    async fetchContractLines({ commit, dispatch, state }, params) {
        commit("updateContractLines", []);
        commit("updateContractLinesLoading", true);
        try {
            const response = await axios.get("/api/contractlines/", { params: state.contractlines_filters });
            commit("updateContractLines", response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateContractLinesLoadingErrors", error.details);
            throw error;
        }
    },

    async deleteContractLine({ commit, dispatch, state }, params) {
        try {
            const url = `/api/contractlines/${params.instance.id}/archive/`;
            const response = await axios.post(url);
            await dispatch("fetchContractLines");
            return response;
        } catch (xhr_error) {
            let errors = utils.handleError(xhr_error);
            throw errors;
        }
    },

    async fetchBillingAccount({ commit, dispatch, state }, params) {
        if (
            store.getters["session/current_user_permissions"].indexOf(
                "billing.view_billingaccount"
            ) == -1
        ) {
            return;
        }
        const response = await dispatch("activebillingaccounts/fetchBillingAccounts");
        if (response?.results && response.results.length > 0) {
            commit("updateBillingAccount", response.results[0]);
        }
    },

    async init({ commit, dispatch, state }, params) {
        commit("updateBillingAccount", null);
        commit("updateStats", null);
        commit("updateCatalogs", null);
        commit("updateCanImpersonate", false);
        commit("updateSection", params.section);
        commit("updateCustomer", params.customer);
        commit("customerstats/updateCustomer", params.customer);

        // Wire submodule URLs/filters only — tab lists fetch on tab mount
        // (same pattern as module-provider).
        await dispatch("documents/init", {
            tags: `customer:${params.customer.id}`,
            create_tags: [`customer:${params.customer.id}`],
        });
        await dispatch("allocations/init", { filters: { customer: params.customer.id } });
        await dispatch("deliverysites/init", {
            url: `/api/customers/${params.customer.id}/deliverysites/`,
        });
        await dispatch("contacts/init", {
            url: `/api/customers/${params.customer.id}/contacts/`,
        });
        await dispatch("communications/init", {
            url: `/api/customers/${params.customer.id}/communications/`,
        });

        if (store.getters["session/current_user_mode"] == "operator") {
            await dispatch("shipments/init", {
                filters: { initiator: params.customer.id, ordering: "-delivery_date" },
            });
            await dispatch("receipts/init", {
                filters: { owner: params.customer.entity },
            });
            await dispatch("stocks/init", { filters: { customer: params.customer.id } });
            // Stocks feed the always-visible warehouse warning banner.
            dispatch("stocks/fetchStocks");
        } else {
            await dispatch("orders/init", {
                url: "/api/customerorders/",
                filters: {
                    ordering: "-creation_date",
                    buyer: params.customer.id,
                    suborder: false,
                },
            });

            await dispatch("products/init", {
                url: `/api/customers/${params.customer.id}/products/`,
                fetch_stats: true,
            });

            await dispatch("shipments/init", {
                filters: {
                    ordering: "-delivery_date",
                    recipient: params.customer.id,
                },
            });
        }

        await dispatch("activebillingaccounts/init", {
            filters: { customer: params.customer.id },
        });

        if (
            store.getters["session/current_user_permissions"].indexOf(
                "catalog.view_catalogassignment"
            ) !== -1 &&
            store.getters["session/current_user_permissions"].indexOf(
                "catalog.view_sellcatalog"
            ) !== -1
        ) {
            await dispatch("catalogassignments/init", {
                filters: {
                    customer: params.customer.id,
                    limit: 20,
                    offset: 0,
                    ordering: "-creation_date",
                },
            });
        }

        if (
            store.getters["session/current_user_permissions"].indexOf(
                "catalog.view_sellcatalog"
            ) !== -1
        ) {
            await dispatch("assignablecatalogs/init", {
                filters: {
                    type: "sell",
                    assignment_customer: params.customer.id,
                    limit: 20,
                    offset: 0,
                    ordering: "-allowed,owner_name,name",
                },
            });
        }

        if (
            store.getters["session/current_entity_profile"] === "operator" &&
            store.getters["session/current_user_permissions"].includes("catalog.view_catalogassignment") &&
            store.getters["session/current_user_permissions"].includes("catalog.view_sellcatalog")
        ) {
            dispatch("catalogassignments/fetchCatalogAssignments").catch(() => {});
        }

        // Always-visible chrome (header / warnings / map / invite).
        dispatch("fetchBillingAccount");
        dispatch("fetchCustomerStats");
        dispatch("fetchOverdueInvoicesStats");
        dispatch("deliverysites/fetchDeliverySites");

        await dispatch("invitations/init", { filters: { customer: params.customer.id } });
        if (!state.customer.entity) {
            dispatch("invitations/fetchInvitations");
        }
        dispatch("checkIfCanImpersonate");
    },

    async cancelCustomerInvitation({ commit, dispatch, state }, params) {
        try {
            await dispatch("invitations/deleteInvitation", {
                instance: state.invitations.invitations[0],
            });
        } catch (error) {
            if (error.code == 400) {
                throw error.details.email_or_safetee_id;
            }
            throw error;
        }
        dispatch("invitations/fetchInvitations");
    },

    async createAccount({ commit, dispatch, state }, params) {
        const { customerId = state.customer.id, ...accountParams } = params;
        commit("updateCreatingAccount", true);
        try {
            let response = await axios.post(
                `/api/customers/${customerId}/createaccount/`,
                accountParams
            );
            commit("updateCreatingAccount", false);
            if (state.customer.id === customerId) {
                dispatch("fetchCustomer");
                dispatch("checkIfCanImpersonate");
            }
            return response.data;
        } catch (xhr_error) {
            commit("updateCreatingAccount", false);
            throw utils.handleError(xhr_error);
        }
    },

    async checkIfCanImpersonate({ commit, dispatch, state }, params) {
        try {
            let response = await axios.head(`/api/customers/${state.customer.id}/impersonate/`);
            commit("updateCanImpersonate", true);
        } catch (xhr_error) {
            commit("updateCanImpersonate", false);
        }
    },

    async saveCustomer({ commit, dispatch, state }, params) {
        try {
            commit("updateCustomerSaving", true);
            let url = `/api/customers/`;
            let method = axios.post;

            if (state.customer.id) {
                url = `/api/customers/${params.customer.id}/`;
                method = axios.put;
            }

            const response = await method(url, params.customer);
            commit("updateCustomerSaving", false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateCustomerSaving", false);
            throw error;
        }
    },

    async deleteInvoice({ commit, dispatch, state }, params) {
        try {
            const response = await axios.delete(`/api/customerinvoices/${params.instance.id}/`);
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            dispatch('session/fetchStats', null, { root: true });
            dispatch('billingstats/fetchAllStats', null, { root: true });
        }
    },

    async update({ commit, dispatch, state }, params) {
        await dispatch("fetchCustomerStats");
        await dispatch("fetchCustomer");
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        documents: documents({
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'documents')
        }),
        allocations: allocations({
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'allocations')
        }),
        customerstats: customerstats({
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'customerstats')
        }),
        activebillingaccounts: billingaccounts({
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'activebillingaccounts')
        }),
        shipments: shipments({ 
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'shipments')
        }),
        receipts: receipts({ 
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'receipts')
        }),
        orders: orders({ 
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'customerorders')
        }),
        deliverysites: deliverysites({
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'deliverysites'),
        }),
        contacts: partnercontacts({
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'contacts'),
            permission: 'core.view_customer',
        }),
        communications: customercommunications({
            fieldsToSave: ['limit'],
            storageKey: getStorageKey('customer', 'communications'),
        }),
        invitations: invitations({
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'invitations')
        }),
        stocks: stocks({
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'stocks')
        }),
        products: products({ 
            fieldsToSave: ['limit', 'ordering'],
            storageKey: getStorageKey('customer', 'products')
        }),
        catalogassignments: catalogassignments({
            fieldsToSave: ["limit", "ordering"],
            storageKey: getStorageKey("customer", "catalogassignments"),
        }),
        assignablecatalogs: catalogsSubmodule({
            fieldsToSave: ["limit", "ordering"],
            storageKey: getStorageKey("customer", "assignablecatalogs"),
        }),
    },
};
